import { useEffect, useMemo } from 'react'

import type { SellingPlan, SellingPlanGroup } from '@lib/types'

interface Props {
	sellingPlanGroups: SellingPlanGroup[]
	selectedSellingPlanId: SellingPlan['id'] | null
	setSelectedSellingPlanId: (id: SellingPlan['id']) => void
}

export default function Subscription({
	sellingPlanGroups,
	selectedSellingPlanId,
	setSelectedSellingPlanId
}: Props) {
	useEffect(() => {
		// Set the selling plan to the first option if none is selected (which will be the case at first)
		const firstSellingPlan = sellingPlanGroups.find((group) => group.sellingPlans.length > 0)
			?.sellingPlans[0].id
		if (!selectedSellingPlanId && firstSellingPlan) {
			setSelectedSellingPlanId(firstSellingPlan)
		}
	}, [selectedSellingPlanId, setSelectedSellingPlanId, sellingPlanGroups])

	return (
		<div className="rounded-lg p-8 border border-gray-200 bg-gray-100 mb-4">
			<h4 className="text-lg mb-4">Subscribe and save</h4>
			<p className="uppercase text-sm text-gray-500 mb-1">Delivery Frequency</p>
			<select
				value={String(selectedSellingPlanId)}
				onChange={(event) => {
					setSelectedSellingPlanId(event.target.value)
				}}
				name="subscription"
				id="subscription"
			>
				{sellingPlanGroups.map((group) => {
					const optionElements = group.sellingPlans.map((plan) => (
						<option key={plan.id} value={plan.id}>
							{plan.name}
						</option>
					))

					return group.sellingPlans.length > 1 ? (
						<optgroup key={group.name} label={group.name}>
							{optionElements}
						</optgroup>
					) : (
						optionElements
					)
				})}
			</select>
		</div>
	)
}
